module.exports = __webpack_public_path__ + "static/media/green-s-10.31f5d98c.png";